"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var mobx_1 = require("mobx");
var mobx_react_1 = require("mobx-react");
var inversify_react_1 = require("inversify-react");
var BemBuilder_1 = __importDefault(require("Utils/BemBuilder"));
var ApiService_1 = require("CreatePageFlow/ApiService");
var AxiosErrorParser_1 = require("Errors/AxiosErrorParser");
var ErrorCodes_1 = require("@CommonFrontendBackend/ErrorCodes/ErrorCodes");
var CreatePageTelemetry_1 = __importDefault(require("../CreatePageTelemetry"));
var utils_1 = require("CreatePageFlow/utils");
var types_1 = require("CreatePageFlow/types");
var TokenResolution_1 = require("CreatePageFlow/steps/TokenResolution");
var c = (0, BemBuilder_1.default)("create-page-flow-object-selection");
var ObjectSelection = (function (_super) {
    __extends(ObjectSelection, _super);
    function ObjectSelection() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.errorMessage = "";
        _this.images = {
            objectSelection: "".concat(types_1.ASSETS_DIR, "Images/createPage/objectIcon.svg"),
        };
        _this.onObjectEntered = function () { return __awaiter(_this, void 0, void 0, function () {
            var _a, store, moveStep, template, objectURL, integration, object, objectId, e_1;
            var _b, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _a = this.props, store = _a.store, moveStep = _a.moveStep;
                        template = store.template, objectURL = store.objectURL;
                        if (!template) {
                            throw new Error("Template required for object selection");
                        }
                        integration = template.crmInfo.integration;
                        object = template.crmInfo.object;
                        _d.label = 1;
                    case 1:
                        _d.trys.push([1, 3, , 4]);
                        objectId = (0, utils_1.extractIntegrationObjectIdFromUrl)(objectURL, integration, object);
                        store.setObjectId(objectId);
                        return [4, (0, TokenResolution_1.resolveTokens)(store, this.apiService, this.telemetry)];
                    case 2:
                        _d.sent();
                        moveStep(1);
                        return [3, 4];
                    case 3:
                        e_1 = _d.sent();
                        if ((0, AxiosErrorParser_1.isAxiosError)(e_1) &&
                            e_1.response &&
                            e_1.response.status === 404 &&
                            ((_c = (_b = e_1.response.data.error) === null || _b === void 0 ? void 0 : _b.additionalInfo) === null || _c === void 0 ? void 0 : _c.errorCode) === ErrorCodes_1.ServerErrorCode.IntegrationObjectNotFound) {
                            this.setErrorMessage("We couldn't find the ".concat((0, utils_1.getSingularObjectName)({
                                object: object,
                                integration: integration,
                            }), " from the provided URL. Please double-check the URL and try again."));
                        }
                        else if ((0, utils_1.isInvalidObjectUrlError)(e_1)) {
                            this.setErrorMessage(e_1.message);
                        }
                        else {
                            this.setErrorMessage(utils_1.GENERIC_ERROR);
                        }
                        throw e_1;
                    case 4: return [2];
                }
            });
        }); };
        return _this;
    }
    ObjectSelection.prototype.setErrorMessage = function (errorMessage) {
        this.errorMessage = errorMessage;
    };
    ObjectSelection.prototype.setObjectUrl = function (objectURL) {
        this.setErrorMessage("");
        this.props.store.setObjectURL(objectURL);
    };
    ObjectSelection.prototype.render = function () {
        var _a, _b;
        var _c = this.props.store, template = _c.template, objectURL = _c.objectURL;
        var integration = template.crmInfo.integration;
        var object = template.crmInfo.object;
        return (react_1.default.createElement("div", { className: c() },
            react_1.default.createElement("img", { className: c("icon"), src: this.images.objectSelection, alt: "" }),
            react_1.default.createElement("div", { className: "space-stack-s" },
                react_1.default.createElement(kaleidoscope_1.Heading, { level: "2" },
                    "Select ",
                    (0, utils_1.getSingularObjectName)({ object: object, integration: integration }).toLowerCase(),
                    " record")),
            react_1.default.createElement("div", { className: "space-stack-xl" },
                react_1.default.createElement(kaleidoscope_1.Text, null,
                    "Paste in ",
                    (0, utils_1.getSingularObjectName)({ object: object, integration: integration }, { prefix: true }),
                    " URL from your CRM.")),
            react_1.default.createElement(kaleidoscope_1.TextInput, { autoFocus: !objectURL, className: c("input"), label: "", placeholder: (0, utils_1.getIntegrationObjectUrlPlaceholder)((_a = template.crmInfo.integration) !== null && _a !== void 0 ? _a : "", (_b = template.crmInfo.object) !== null && _b !== void 0 ? _b : ""), onChange: this.setObjectUrl, value: objectURL }),
            this.errorMessage && (react_1.default.createElement(kaleidoscope_1.Alert, { className: c("error"), alertType: kaleidoscope_1.AlertType.Error, heading: "Error" }, this.errorMessage)),
            react_1.default.createElement(kaleidoscope_1.Button, { type: kaleidoscope_1.ButtonType.Primary, disabled: !objectURL, onClick: this.onObjectEntered }, "Next")));
    };
    var _a, _b;
    __decorate([
        inversify_react_1.resolve,
        __metadata("design:type", typeof (_a = typeof ApiService_1.ApiService !== "undefined" && ApiService_1.ApiService) === "function" ? _a : Object)
    ], ObjectSelection.prototype, "apiService", void 0);
    __decorate([
        inversify_react_1.resolve,
        __metadata("design:type", typeof (_b = typeof CreatePageTelemetry_1.default !== "undefined" && CreatePageTelemetry_1.default) === "function" ? _b : Object)
    ], ObjectSelection.prototype, "telemetry", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Object)
    ], ObjectSelection.prototype, "errorMessage", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", void 0)
    ], ObjectSelection.prototype, "setErrorMessage", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", void 0)
    ], ObjectSelection.prototype, "setObjectUrl", null);
    ObjectSelection = __decorate([
        mobx_react_1.observer
    ], ObjectSelection);
    return ObjectSelection;
}(react_1.default.Component));
exports.default = ObjectSelection;
